import { ApiServiceV1 } from '@services/api.service';

export default {
  async getSubstrates({
    suffix, state = null, name = null,
    pageNum = 1, pageSize = 10,
  }) {
    const { data } = await ApiServiceV1.get(`${suffix}/substrate`, {
      params: {
        state, name, pageNum, pageSize,
      },
    });
    return data || {};
  },
  createSubstrate({ suffix, data }) {
    return ApiServiceV1.post(`${suffix}/substrate`, data);
  },
  updateSubstrate({ suffix, name, data }) {
    return ApiServiceV1.post(`${suffix}/substrate/${encodeURIComponent(name)}`, data);
  },
};
